import { Image } from '@cian/ui-kit/image';
import { Link } from '@cian/ui-kit/link';
import { ArticleHeading3, Body2 } from '@cian/ui-kit/typography';
import type { ReactNode } from 'react';

import { NoPhoto } from 'shared/components/common/NoPhoto';
import type { IBuildingBlock } from 'shared/types/buildingOffers';
import { getBlockOffers } from 'shared/utils/buildingOffers';

import style from './style.css';

export interface IBuildingBlocksProps {
  blocks: IBuildingBlock[];
  /** Сразу под предложениями — общий серый фон, без верхнего отступа */
  isAfterOffers: boolean;
}

const BlockLink = ({ url, className, children }: { url: string | null; className: string; children: ReactNode }) =>
  url ? (
    <a href={url} className={className}>
      {children}
    </a>
  ) : (
    <div className={className}>{children}</div>
  );

/** Блок «Корпуса» (`object_corps.tsx` монолита): фото, название и адрес ведут на корпус */
export const BuildingBlocks = ({ blocks, isAfterOffers }: IBuildingBlocksProps) => (
  <section className={style['section']} data-name="BuildingBlocks">
    <div className={`${style['container']} ${isAfterOffers ? '' : style['container--first']}`}>
      <ArticleHeading3 as="h2">Корпуса</ArticleHeading3>
      <div className={style['list']}>
        {blocks.map(block => (
          <div key={block.id} className={style['block']} data-name="BuildingBlock">
            <BlockLink url={block.url} className={style['photo']}>
              {block.photoUrl ? (
                <Image src={block.photoUrl} alt="" objectFit="cover" width="100%" height="100%" borderRadius={0} />
              ) : (
                <NoPhoto variant="block" />
              )}
            </BlockLink>
            <div className={style['details']}>
              <BlockLink url={block.url} className={style['title']}>
                <Body2 fontWeight="bold">{block.name}</Body2>
                <Body2 color="text-secondary-default">{block.address}</Body2>
              </BlockLink>
              <div className={style['offers']}>
                {getBlockOffers(block).map(({ title, area, link }) => (
                  <div key={title} className={style['column']}>
                    <Body2>{title}</Body2>
                    <Body2 fontWeight="bold">{area}</Body2>
                    {link && (
                      <Link href={link.url} fontSize="S">
                        {link.text}
                      </Link>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
